export interface CsCardListInterface {
  updatePositions(): void;
  // When true, skip animation suppression during drag operations
  allowDragAnimations: boolean;
  // true while the list hasn't completed initial layout (e.g., hidden in inactive tab)
  initializing: boolean;
}

export class CsCardListInterfaceClass implements CsCardListInterface {
  allowDragAnimations = false;
  initializing = true;
  updatePositions() { }
};